
export function enableClickable(reset = false) {

    console.log("[app-behaviors] Installing clickable behavior (data-onclick)");

    if (reset) $("[data-onclick]").off("click");

    $("[data-onclick]").on("click",
        e => {

            // Ignore if click is on a link
            if (e.currentTarget != e.target && $(e.target).is("a, a *, input"))
                return;

            const $tgt = $(e.currentTarget);

            // Check for data link
            const url = $tgt.attr("data-onclick");

            if (url !== undefined) {

                // Click to toggle checkbox
                if (url === "togglecheck") {
                    e.preventDefault();

                    $tgt.find(":checkbox").click();

                    return;
                }
                // Click to set val or txt
                else if (url === "update") {

                    e.preventDefault();

                    const valtgt = $tgt.attr('data-val-target');

                    if (valtgt !== undefined) {
                        $(valtgt).val($tgt.attr('data-val') || $tgt.text());
                    }

                    const txttgt = $tgt.attr('data-txt-target');

                    if (txttgt !== undefined) {
                        $(txttgt).text($tgt.attr('data-txt') || $tgt.text());
                    }

                    return;
                }

                window.location.href = url;
                e.stopPropagation();
            }
        });
}
